import { render, staticRenderFns } from "./PiecingTogetherIcon.vue?vue&type=template&id=9080c93c&"
import script from "./PiecingTogetherIcon.vue?vue&type=script&lang=js&"
export * from "./PiecingTogetherIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports